'use strict';

const priceManagerCollection = require('od-modules/collections/pricemanager.collection').getInstance();
const insuranceCatalogueCollection = require('od-modules/collections/insurance_catalogue.collection').getInstance();
const serviceOptionsCollection = require('od-modules/collections/service_options.collection').getInstance();
const flightDetailsCollection = require('od-modules/collections/flight_details.collection').getInstance();
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();

const getPromises = () => [
    priceManagerCollection.getLoadedPromise(),
    insuranceCatalogueCollection.getLoadedPromise(),
    serviceOptionsCollection.getLoadedPromise(),
    flightDetailsCollection.getLoadedPromise(),
    websiteConfigCollection.getLoadedPromise(),
];

module.exports = {
    loadCollections(callback = () => {}) {
        Promise.all(getPromises()).then((results) => {
            if (results.reduce((result, item) => result && item)) {
                callback();
            }
        });
    },
    collections: {
        cart: priceManagerCollection,
        insurances: insuranceCatalogueCollection,
        serviceOptions: serviceOptionsCollection,
        flightDetails: flightDetailsCollection,
        websiteConfig: websiteConfigCollection,
    },
};
